import { render, staticRenderFns } from "./RatingBreakdown.vue?vue&type=template&id=121d360c&scoped=true"
import script from "./RatingBreakdown.vue?vue&type=script&lang=js"
export * from "./RatingBreakdown.vue?vue&type=script&lang=js"
import style0 from "./RatingBreakdown.vue?vue&type=style&index=0&id=121d360c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121d360c",
  null
  
)

export default component.exports